import React, { Component } from "react";
import axios from "axios";
// import $ from 'jquery';
import Select from "react-select";
import MyContext from '../MyContext.jsx';
import './Login.scss';
var apk_url = '';
class Login extends Component {
  constructor(props,context) {
    super(props,context);
    this.state = {
      options : [],
      username : "",
      password : "",
      division_id : "",     
    }
    this.formChange = this.formChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.getDevicePlatform = this.getDevicePlatform.bind(this);
    this.getDeviceModel = this.getDeviceModel.bind(this);

  }

  componentDidMount(){ 
    var user_details = JSON.parse(window.localStorage.getItem('user_details_alsafas_emak_app'));
    if(user_details){
      this.setState({
        username : user_details.username,
        password : user_details.password,
      });
    }
    if (typeof geo !== 'undefined') {
      geo.getLocation((location) => {
        if(location && location.latitude) this.context.setLocation(location);
      });
    }
    const sid = user_details && user_details.sid ? user_details.sid : "";
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : process.env.REACT_APP_SSS +"/api/checkLoginToken",
      data : {
        "sid" : sid,
        "version" : obj_this.context.version
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if("divisions" in return_data){
        obj_this.setState({
          options : return_data.divisions,
        });
      }
      if(return_data.status == "success"){
        delete return_data.status;
        obj_this.context.setUserDetails(return_data);
        return_data.username  = user_details.username;
        return_data.password  = user_details.password;
        window.localStorage.setItem("user_details_alsafas_emak_app",JSON.stringify(return_data));
        obj_this.props.history.replace('/dashboard');
        
      }else if(return_data.status == "fail"){
        // window.localStorage.removeItem("user_details_alsafas_emak_app");
        window.localStorage.removeItem("alsafas_emak_customers_cache");
        window.localStorage.removeItem("alsafas_emak_customers_cache_expiry");

        window.sessionStorage.clear();
        var promises = [];
        if (window.caches) {
          promises.push(
            window.caches.keys().then(function(keys) {
              return Promise.all(keys.map(function(key) {
                return window.caches.delete(key);
              }));
            })
          );
        }
        if (navigator.serviceWorker) {
          promises.push(
            navigator.serviceWorker.getRegistrations().then(function(registrations) {
              return Promise.all(registrations.map(function(registration) {
                return registration.unregister();
              }));
            })
          );
        }
        Promise.all(promises).catch(function(e) { console.error("Cache clear error", e); });
        if("url" in return_data){
          $(".update_apk_container, .ghost").css("display","block");
          apk_url = return_data.url;
        }else{
          $(".login_error").css("display","block");
        }
      }
      $(".login_page_container").css("visibility","visible");
      obj_this.context.loading(0);
    }).fail(function(jqXHR, textStatus, errorThrown){
      console.log("checkLoginToken failed", {
        url: process.env.REACT_APP_SSS + "/api/checkLoginToken",
        status: jqXHR && jqXHR.status,
        responseText: jqXHR && jqXHR.responseText,
        textStatus,
        errorThrown
      });
      alert("Network error22 (status: " + ((jqXHR && jqXHR.status) || 0) + ")");
    });

    $(".update_apk_container").on("click",function(){
      const cb = new Date().getTime();
      const finalUrl = apk_url.includes('?') ? `${apk_url}&cb=${cb}` : `${apk_url}?cb=${cb}`;
      
      if (typeof cordova !== 'undefined' && cordova.InAppBrowser) {
        var ref = cordova.InAppBrowser.open(finalUrl, '_system');
      } else {
        if (window.confirm("Do you want to open your browser to download the update?")) {
          var opened = window.open(finalUrl, '_blank');
          if (!opened) {
            window.prompt("Please copy this link and open it in your browser to download the update:", finalUrl);
          }
        }
      }
    });

  }

  categoryChange(option){
    // console.log(option);
    this.setState({
      division_id : option.value
    });    
  }

  formChange(e){
    this.setState({
      [e.target.name] : e.target.value
    });
  }

  submitForm(e){
    e.preventDefault();
    if(this.state.division_id == ""){
      this.refs.focus();
      return;
    }

    this.context.loading(1);
    const url = `${process.env.REACT_APP_SSS}/api/login`;
    var obj_this = this;
    $.ajax({
      url : url,
      data : {
        "username" : this.state.username,
        "password" : this.state.password,
        "division_id" : this.state.division_id,
        "version" : this.context.version
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        delete return_data.status;
        obj_this.context.setUserDetails(return_data);
        window.localStorage.setItem("user_details_alsafas_emak_app",JSON.stringify(return_data));
        obj_this.context.loading(0);
        obj_this.props.history.replace('/dashboard');
      }else{
        $(".login_error").css("display","block");
      }
      obj_this.context.loading(0);
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
  }

  getDevicePlatform = () => {
    if (window.cordova && window.device && window.device.platform) {
      return window.device.platform;
    } else if (navigator.userAgent.match(/Android/i)) {
      return 'Android';
    } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      return 'iOS';
    } else {
      return 'Unknown';
    }
  };

  // Function to get the device model using cordova-plugin-device
  getDeviceModel = () => {
    if (window.cordova && window.device && window.device.model) {
      return window.device.model;
    } else {
      return 'Unknown';
    }
  };


  render(){
  return (
    <MyContext.Consumer>
      {context => (
        <div className="login_page_container">
          <div className="footer">
            <div className="developed_by">Developed by</div>
            <img src={window.project_path+"/images/company_logo.png"} height="35px" />
            <div className="version">Ver {this.context.version}</div>
          </div>
          <form className="login_form"
            onSubmit={e =>this.submitForm(e)}
          >
            <img className="company_logo" src={window.project_path+"/images/company_logo.png"} height="50px;" />
            {/* <b style={{fontSize: "36px",color:"#ff0202"}}>E-MAK</b> */}
            <div className="input_container">
              <div className="input_icon"><i className="fas fa-user"></i></div>
              <input 
                type="text" 
                name="username" 
                placeholder="Username" 
                required 
                value = {this.state.username}
                onChange={this.formChange}
                autoComplete="off"
              />
            </div>
            <div className="input_container">
              <div className="input_icon"><i className="fas fa-lock"></i></div>
              <input 
                type="password" 
                name="password" 
                placeholder="Password" 
                required
                value={this.state.password}
                onChange={this.formChange}
                autoComplete="off"
              />
            </div>
            <div className="select_container">
              <Select 
                options={this.state.options}  
                // defaultValue={{ label: "Division", value: 0 }}
                placeholder={<div className="pholder">Branch</div>} 
                ref={r => {
                  this.refs = r;
                }} 
                className="division_select" 
                onChange={e => this.categoryChange(e)}
                required
              />
              <div className="input_icon"><i className="fas fa-building"></i></div>
            </div>
            <div className="login_error">*Credentials incorrect</div>
            <button 
              className="login_button" 
              type="submit"
            >Login</button>
          </form>
        
          
          <div className="ghost"></div>
          <div className="update_apk_container">
            <div className="update_message">You are using outdated version. Download new app</div>
            <div className="update_apk_button"><i className="fas fa-download"></i> Download</div>
          </div>
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default Login;
Login.contextType = MyContext;